var event = {
    configs : {
        eventName: 'streamLive'
    },
    validarFormAInterested: function (dataCountry) {
        var tagPhoneId = "#inputPhoneNumberInteresting";
        var tagSuccessId = "#messageSuccess";
       
        if (!dataCountry) {
            dataCountry = 'co'
        }
        var inputPhoneNumberReg = document.querySelector(tagPhoneId);
        var intPhoneNumberReg = intlTelInput(inputPhoneNumberReg, {
          initialCountry: dataCountry,
          //utilsScript: main.host + "dist/js/utils.js",
          utilsScript: "https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js?1549804213570",
          preferredCountries: ['pe', 'co', 'mx','ar', 'es', 'us'],
          placeholderNumberType: "MOBILE",
          separateDialCode: true
        });
            
        $('#formPersonInterested').validate({
          rules: { 
            inputFullName:{required: true},
            inputPhoneNumber:{required: true},
            inputEmailAddress: {
                required: true, 
                email: true
                }
          }, 
          messages:{
            inputFullName:{required: 'Ingrese su Nombre.'},
            inputPhoneNumber:{required: 'Ingrese un número.'},
            inputEmailAddress:{required: 'Ingrese su E-mail.'}  
          },  
          errorPlacement: function(error, element) {
              error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
          },
          submitHandler: function (form){ 
              var params = $('#formPersonInterested').serialize();
              params += '&phoneCode=' + intPhoneNumberReg.getSelectedCountryData().dialCode;
              $.ajax({
                  url: "/es/marketplace/process/event-form-interested",  
                  data: params,
                  type: 'POST',
                  dataType: "json",
                  success : function(data) {
                    if(data.success) {
                        if(data.redirect) {
                            location.href = data.redirectUri;
                        } else {
                            $('#messageSuccess').html('<p>' + data.message + '</p>');
                        }
                    } else {
                        swal({
                            title:"Se produjo un error",
                            text:data.message, 
                            type: "error",
                            confirmButtonColor: "#039BE5"
                        });
                    }
                  }
              });
            }
        });
    },
    registerEventFree: function (countryCode, publicationId) {
        // var intPhoneNumber = event.validationInputPhoneCode('inputPhoneNumber', countryCode);
        if($("#inputPhoneNumberInteresting").length){
            var inputPhoneNumberReg = document.querySelector("#inputPhoneNumberInteresting");
            var intPhoneNumberReg = intlTelInput(inputPhoneNumberReg, {
              initialCountry: countryCode,
              //utilsScript: main.host + "dist/js/utils.js",
              utilsScript: "https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js?1549804213570",
              preferredCountries: ['pe', 'co', 'mx','ar', 'es', 'us'],
              placeholderNumberType: "MOBILE",
              separateDialCode: true
            });
          }    
        $('#formEventOnlineRegister').validate({
            rules: {
                inputFullName: {required: true},
                inputEmailAddress: {
                    required: true,
                    email: true
                },
                inputPassword: {required: true},
                inputPhoneNumber: {required: true}
            },
            messages: {
                inputFullName: {required: 'Ingrese su Nombre.'},
                inputEmailAddress: {required: 'Ingrese su E-mail.'},
                inputPassword: {required: 'Ingrese su nueva contraseña'},
                inputPhoneNumber: {required: 'Ingrese un número.'}
            },
            errorPlacement: function (error, element) {
                error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
            },
            submitHandler: function (form) {
                $('#formEventOnlineRegister button').attr("disabled", true);
                var textButtom = $('#formEventOnlineRegister button').text();
                $('#formEventOnlineRegister button').text("Procesando..");
                var params = $(form).serialize();
                if($("#inputPhoneNumberInteresting").length){
                    params += '&phoneCode=' + intPhoneNumberReg.getSelectedCountryData().dialCode + '&publicationId=' + publicationId;
                }
                
                $.ajax({
                    url: "/es/page/new-interested",
                    data: params,
                    type: 'POST',
                    dataType: "json",
                    success: function (data) {
                        if (data.success) {
                            $("#idMessageSuccess").html('<p>' + data.message + '</p>');
                            if(data.redirect) {
                                console.log(data.redirectUri);
                                $("#content-form-register").html('<div class="form-group"><a class="btn-l-primary" href="' + data.redirectUri +'">Acceder</a></div>');
                            }
                        } else {
                            title = "Se produjo un error";
                            if(data.type == 'warning') {
                                 title = "Correo ya existente";
                            }
                            document.getElementById('security').value = data.security;
                            swal({
                                title: title,
                                 //text: data.message,
                                type: data.type,
                                confirmButtonColor: "#039BE5",
                                html:data.message,
                                confirmButtonText: 'Ingresar',
                                onClose: openLogin
                            });
                            $('#formEventOnlineRegister button').attr("disabled", false);
                            $('#formEventOnlineRegister button').text(textButtom);
                            function openLogin(){
                                $('#loginModal').modal('show');  
                            }
                        }
                    }
                });
            }
        });
        return false;
    },
    registerEventFreeLogin: function (publicationId) {
        console.log(publicationId);
        $('#formEventOnlineRegister button').attr("disabled", true);
        var textButtom = $('#formEventOnlineRegister button').text();
        $('#formEventOnlineRegister button').text("Procesando..");
        $.ajax({
            url: "/es/page/new-interested",
            data: {
                'publicationId': publicationId,
                'type': $("#type").val()
            },
            type: 'POST',
            dataType: "json",
            success: function (data) {
                if (data.success) {                    
                    if (data.redirect) {
                        location.href = data.redirectUri;                    
                    } else {
                        $("#idMessageSuccess").html('<p>' + data.message + '</p>');
                        $("#content-form-register").html('<div class="form-group"><a class="btn-l-primary" href="' + data.redirectUri +'">Acceder</a></div>');
                    }       
                } else {
                    document.getElementById('security').value = data.security;
                    swal({
                        title: "Se produjo un error",
                        text: data.message,
                        type: 'error',
                        confirmButtonColor: "#039BE5",
                        html:data.message,
                        confirmButtonText: 'Ingresar'
                    });
                    $('#formEventOnlineRegister button').attr("disabled", false);
                    $('#formEventOnlineRegister button').text(textButtom);
                }
            }
        });
    },
    validationInputPhoneCode: function(nameInput, countryCode)
    {
        var intPhoneNumber = '';
        if ($("#" + nameInput).length) {
            if (!countryCode) {
                countryCode = 'co';
            }
            var inputPhone = document.querySelector("#" + nameInput);
            intPhoneNumber = intlTelInput(inputPhone, {
                initialCountry: countryCode,
                //utilsScript: main.host + "dist/js/utils.js",
                utilsScript: "https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js?1549804213570",
                preferredCountries: ['pe', 'co', 'mx', 'ar', 'es', 'us'],
                placeholderNumberType: "MOBILE",
                separateDialCode: true
            });
        }
        return intPhoneNumber;
    },
    roomListQuotes: function (id, countryCode) {
        $.ajax({
            url: "/es/event/quotes/" + id + '/' + countryCode,
            //data: {'slug': slug},
            type: 'GET',
            dataType: "json",
            beforeSend: function() {
                if(id){
                    $("#quote-list").html('Procesando...');
                }
             },
            success: function (data) {
                if(data.html) {
                    $("#quote-list").html(data.html);
                    $('.addEventCalendar').addToCalendar({
                        filename: 'mi-calendario', // filename download for ical excluding extension
                        target: '_blank', // specifies the target attribute of the window
                        providers: {
                          google: 'Google Calendar', // provider name and label
                          outlook: 'Outlook Calendar', // provider name and label
                          yahoo: 'Yahoo! Calendar', // provider name and label
                          other: 'Other Calendar' // other property force download event as .ics for ical
                        },
                        onAddEvent: function() {} // callback after click provider link
                    });
                }
            }
        });
    },
    roomLiveStream: function(id) {
        $.ajax({
            url: "/es/event/live-stream/" + id,
            //data: {'slug': slug},
            type: 'GET',
            dataType: "json",
            beforeSend: function() {
                // --
             },
            success: function (data) {
                if(data.liveStream) {
                    $('#id-stream').show();
                    $('#id-next-event').css('display', 'none');
                    
                    var player = jwplayer("idMedia").setup({
                        "file": data.liveStream,
                        "autostart": "false",
                    })
                    setTimeout(function(){ player.play() }, 3000);
                    player.on('error', function(event){
                        this.stop();
                    });
                } else if(data.dateQuotes) {
                    $('#id-stream').css('display', 'none');
                    $('#id-next-event').show();

                    console.log(data.dateQuotes);
                    $('.listTiempo').data('countdown', data.dateQuotes);
                    custom.countDown();
                }
            }
        });
    },
    getPusherLive: function() {
        console.log('pusher');
        pusher = new Pusher(og.params.key)
        var channel = pusher.subscribe(og.params.channelNameLive);
        channel.bind(event.configs.eventName, function(data) {
            console.log('pusher renderStream');
            event.roomLiveStream(data.productId);
        });

    }
}
